window.$ = window.jQuery = require("jquery");
const { leadConversion } = require("./util");

export function promoFlowBannerShow() {
    $(".promo-flow-banner").slideDown();
}

export function promoFlowBannerClose() {
    $(".promo-flow-banner").slideUp(400, function () {
        $(".promo-flow-banner").remove();
    });
    $.ajax({
        type: "POST",
        url: "/api/promo/close",
        dataType: "json"
    });
}

export function showSignupForm() {
    $(".signup .dismiss").hide();
    $(".signup-toggle-text").hide();
    $(".signup-toggle-close").show();
    $(".signup-form").slideDown();
}

export function hideSignupForm() {
    $(".signup-form").slideUp();
    $(".signup-toggle-close").hide();
    $(".signup .dismiss").show();
    $(".signup-toggle-text").show();
}

export function PromoManager(route, selector, event, label) {
    var self = this;
    self.event = event;
    self.label = label || "";
    self.route = route;
    self.success = window.jrConfig.promoSuccess || null;
    self.failure = window.jrConfig.promoFailure || null;

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: "GAEvent",
        eventCategory: self.event,
        eventAction: "view",
        eventLabel: self.label,
        eventValue: ""
    });

    self.showError = function(form, message) {
        var msg = message || "We're sorry. An unexpected error occurred. Please try again later!";
        if (/new customers/.test(message)) {
            $(".promo-input").hide();
            $(".promo-submit").hide();
            if (!self.failure) {
                $(".promo-flow-banner").remove();
            }
        } else {
            $(".promo-submit").show();
        }
        $(".promo-error")
            .html(msg)
            .fadeIn("slow");
        if (self.failure) {
            self.failure(msg);
        }
    };

    $(selector).validate({
        submitHandler: function(form) {
            $(".promo-error").hide();
            $(".promo-submit").hide();
            $(".promo-loading").show();
            $.ajax({
                type: "POST",
                url: self.route,
                data: $(form).serialize(),
                dataType: "json"
            })
                .done(function(resp) {
                    $(".promo-loading").hide();
                    if (resp.success) {
                        leadConversion(self.event, self.label);

                        $(".promo-input").hide();
                        $(".promo-text").hide();

                        $(".promo-success").fadeIn("slow");
                        $.each(resp.data, function(field, value) {
                            $(".promo-discount-" + field).html(value);
                        });
                        if (self.success) {
                            self.success(resp);
                        } else {
                            $(".promo-flow-banner").remove();
                        }
                    } else {
                        self.showError(form, resp.error.message);
                    }
                })
                .fail(function(jqXHR /* textStatus, errorThrown */) {
                    $(".promo-loading").hide();
                    var resp = jqXHR.responseJSON || { error: {} };
                    if (jqXHR.status == 422 && resp.email) {
                        // Validation error
                        self.showError(form, resp.email.join("<br>"));
                    } else {
                        self.showError(form, resp.error.message);
                    }
                });
        },
        rules: {
            email: {
                required: true,
                email: true
            }
        }
    });
}

export default {
    PromoManager: PromoManager,
    promoFlowBannerShow: promoFlowBannerShow,
    promoFlowBannerClose: promoFlowBannerClose,
    showSignupForm: showSignupForm,
    hideSignupForm: hideSignupForm
};
